import { useEffect, useState } from 'react';

export default function ConfidenceMeter({ score = 0, size = 80, label = 'Confidence' }) {
  const [animated, setAnimated] = useState(0);
  const radius = (size - 12) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (animated / 100) * circumference;

  const color =
    animated >= 80 ? '#00C896' : animated >= 60 ? '#FFB300' : '#FF3B3B';

  useEffect(() => {
    const timer = setTimeout(() => setAnimated(score), 100);
    return () => clearTimeout(timer);
  }, [score]);

  return (
    <div className="flex flex-col items-center gap-1">
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        aria-label={`${label}: ${score}%`}
        role="img"
      >
        {/* Background ring */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="rgba(30,42,69,0.8)"
          strokeWidth="6"
        />
        {/* Progress ring */}
        <circle
          className="confidence-circle"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth="6"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 1s ease-out, stroke 0.3s' }}
        />
        {/* Text */}
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={color}
          fontSize={size < 70 ? 10 : 13}
          fontFamily="Orbitron, sans-serif"
          fontWeight="bold"
        >
          {animated}%
        </text>
      </svg>
      <span className="text-xs text-gray-400 font-mono">{label}</span>
    </div>
  );
}
